import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns/format';

import { getLongDateFormat } from '@optical/utils';

@Pipe({
  name: 'time',
})
export class TimePipe implements PipeTransform {
  transform(
    value: Date | number | null | undefined,
    options: { seconds: boolean } = { seconds: false },
  ): string | null {
    if (value === null || value === undefined) return null;

    return format(value, getLongDateFormat(options.seconds ? 'LTS' : 'LT'));
  }
}
